export default "__VITE_ASSET__BXlbz45U__"